export class FileSnapshotError extends Error {
  readonly cause: unknown;

  constructor(file: File, cause: unknown) {
    super(`Could not read "${file.name}". Save and close the file, then select it again, or select a separately saved copy.`);
    this.name = 'FileSnapshotError';
    this.cause = cause;
  }
}

/**
 * Copy a browser-selected file into an app-owned File while preserving the
 * metadata used by upload and duplicate-detection flows.
 */
export async function snapshotFile(file: File): Promise<File> {
  try {
    const contents = await file.arrayBuffer();
    return new File([contents], file.name, {
      type: file.type,
      lastModified: file.lastModified,
    });
  } catch (error) {
    throw new FileSnapshotError(file, error);
  }
}

/**
 * Snapshot in sequence to avoid materializing every selected file's
 * ArrayBuffer at once. The returned Files remain independent of the originals.
 */
export async function snapshotFiles(files: File[]): Promise<File[]> {
  const snapshots: File[] = [];
  for (const file of files) snapshots.push(await snapshotFile(file));
  return snapshots;
}
